import React, { Component } from "react";
import { connect } from "react-redux";

import {
  searchSchools,
  fetchSchools,
  createSchools,
  fetchIndustries,
  getCommuteCities
} from "../../../../actions/dropdowns.actions";
import {
  searchCompanies,
  fetchCompanies,
  createCompany
} from "../../../../actions/company.actions";
import { updateUserData } from "../../../../actions/user.actions";
import CompleteProfile from "../components/CompleteProfile";

class CompleteProfileContainer extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    this.props.fetchCompanies();
    this.props.fetchIndustries();
    this.props.fetchSchools();
    this.props.getCommuteCities();
  }

  handleSubmit(data) {
    if (data.city && data.city.length > 0) {
      data.city = data.city[0].description;
    }
    this.props.updateUserData({ ...data }, "/member/skills");
  }

  render() {
    return (
      <CompleteProfile
        onSubmit={this.handleSubmit}
        companies={this.props.companies}
        schools={this.props.schools}
        industries={this.props.industries}
        createCompany={this.props.createCompany}
        createSchools={this.props.createSchools}
        isLoadingCompany={this.props.isLoadingCompany}
        isLoadingSchools={this.props.isLoadingSchools}
        onSearchSchools={this.props.searchSchools}
        onSearchCompanies={this.props.searchCompanies}
        commuteCities={this.props.commuteCities}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    commuteCities: state.dropdowns.commuteCities.data,
    companies: state.company.companies.data,
    industries: state.dropdowns.industries.data,
    schools: state.dropdowns.schools,
    isLoadingCompany: state.company.isLoading,
    isLoadingSchools: state.dropdowns.isLoading
  };
};

const mapDispatchToProps = dispatch => ({
  fetchCompanies: () => dispatch(fetchCompanies()),
  fetchIndustries: () => dispatch(fetchIndustries()),
  fetchSchools: () => dispatch(fetchSchools()),
  createCompany: company => dispatch(createCompany(company)),
  createSchools: query => dispatch(createSchools(query)),
  searchCompanies: query => dispatch(searchCompanies(query)),
  searchSchools: query => dispatch(searchSchools(query)),
  updateUserData: (user, redirect) => dispatch(updateUserData(user, redirect)),
  getCommuteCities: () => dispatch(getCommuteCities())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompleteProfileContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/completeProfile/containers/CompleteProfileContainer.js